import React from 'react'
import Helmet from 'react-helmet'
import favicon16 from "../assets/images/favicon16.png";
import favicon32 from "../assets/images/favicon32.png";
import favicon64 from "../assets/images/favicon64.png";

import trusted_providers_img from '../assets/images/trusted_providers.jpg'
import rekon_advantage_img from '../assets/images/rekon_advantage.jpg'
const AboutPage = () => (
  <div>
  <Helmet
    title="About Rekon Technologies"
    meta={[
      { name: 'description', content: 'About Rekon Technologies' }
    ]}
       link={[
        { rel: "icon", type: "image/png", sizes: "16x16", href: `${favicon16}` },
        { rel: "icon", type: "image/png", sizes: "32x32", href: `${favicon32}` },
        { rel: "shortcut icon", type: "image/png", href: `${favicon64}` },
       ]}
  />
    <section className="hero hero-about is-medium is-bold">
      <div className="hero-body">
        <div className="container">
          <h1>
            <span className="line-1">
              The Pioneers of
            </span>
            <span className="line-2">
              Recording Technology
            </span>
          </h1>
        </div>
      </div>
    </section>
    <div className="section about-us">
      <div className="container">
        <div className="columns is-multiline">
          <div className="column is-6-desktop content-panel">
            <h2>The Industry’s Most Trusted Provider</h2>
            <p>
            Founded in 1994, Rekon Technologies pioneered the automation of the highly complex task of completing lien releases and assignments. The company’s solutions enable servicers to quickly and easily prepare, record, manage and track a wide range of loan documents. 
            <br/><br/>
            The company’s flagship software, Rekon, is used by the majority of the mortgage industry’s largest servicers. Reliable and scalable, Rekon is designed to handle document preparation and recording in the more than 3,600 recording offices in all 50 states.
            <br/><br/>
            DokTrak, the company’s advanced document management and tracking technology, connects your entire servicing operation with a single comprehensive solution.  DokTrak is the one-stop hub for managing all loan documents.
            <br/><br/>
            There are more than a million ways something can go wrong with lien releases, assignments and managing mortgage documents. That’s why more servicers choose one company to get the job done right—Rekon Technologies. 
            
            </p>
          </div>
          <div className="column is-5-desktop is-offset-1-desktop content-image">
            <img src={trusted_providers_img} alt="Placeholder Image" />
          </div>
        </div>
      </div>
      <div className="container">
        <div className="columns is-multiline">
          <div className="column is-5-desktop content-image">
            <img src={rekon_advantage_img} alt="Placeholder Image" />
          </div>
          <div className="column is-6-desktop is-offset-1-desktop content-panel">
            <h2>The Rekon Advantage</h2>
            <p>
              When you work with Rekon, you’re working with the industry’s experts in lien releases, assignments and document management.  Our experience come from successfully helping and advancing servicers of all sizes throughout the years, including a majority of the top 10 servicers in the mortgage industry. 

              <br/><br/>
              
              <strong>20 Years of Innovation</strong>
              <br/><br/>
              
              For over two decades, Rekon has set the bar by continuing to innovate and refine its technology solutions. And for the last four years, the company has been named to HousingWire magazine’s prestigious HW TECH100™ list of top technology firms serving the real estate and finance industries. 
              <br/><br/>
              Rekon’s specialty is constant technology innovation and pinpoint accuracy, which are vital for helping lenders and servicers avoid delays and costly penalties on millions of real estate transactions across the country. As the choice of the nation’s top servicers, Rekon continues to set the industry standard in lien releases, assignments, and document management. 
            
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/about.js